import { ExportJobDestinationType, ExportJobStatus } from "@supernova-studio/model";
import { z } from "zod";

export const DTOExportJobsListFilter = z.object({
  exporterId: z.string().optional(),
  designSystemVersionId: z.string().optional(),
  createdByUserId: z.string().optional(),
  status: ExportJobStatus.optional(),
  scheduleId: z.string().optional(),
  designSystemId: z.string().optional(),
  themeId: z.string().optional(),
  brandId: z.string().optional(),
  destinations: z
    .string()
    .transform(s => s.split(",").map(p => ExportJobDestinationType.parse(p)))
    .optional(),
});

export type DTOExportJobsListFilter = z.infer<typeof DTOExportJobsListFilter>;
